import React, { useContext, useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { ConfigContext } from "../context/GlobalContext";
import * as actionType from "../context/actions";
import PaginationView from "./PaginationView";
import { FilterdData } from "../helper/FilterdData";
import DataNotFoundView from "./DataNotFoundView";
import { useNavigate } from "react-router-dom";
import { Languages } from "../Utils/Languages";
import { FreePlanLimitReachedModal } from "./FreePlanLimitReached";
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import DeleteBusinessView from "./DeleteBusinessView";


const BusinessTableDataLayer = ({ BusinessData }) => {

    const navigate = useNavigate();

    const { state, dispatch } = useContext(ConfigContext);
    const [filterdBusinessData, setFilterdBusinessData] = useState(BusinessData);
    const [isDisplayLimitModel, setIsDisplayLimitModel] = useState(false);
    const [limitPlanName, setLimitPlanName] = useState("Free Plan");
    const [limitValue, setLimitValue] = useState(1);


    useEffect(() => {
        // Select all elements with data-bs-toggle="DefaultTooltipThree"
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="DefaultTooltipThree"]');
        // Initialize tooltips
        const tooltipList = Array.from(tooltipTriggerList).map(
            (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
        );
        // Cleanup on unmount
        return () => {
            tooltipList.forEach((tooltip) => tooltip.dispose());
        };
    }, []);

    useEffect(() => {
        setFilterdBusinessData(state?.BUSINESSES)
    }, [state?.BUSINESSES])



    useEffect(() => {
        setFilterdBusinessData(FilterdData(state, BusinessData, "creationDate"));
    }, [state?.ACTIVEFILTER])

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);


    // Pagination logic
    const totalPages = Math.max(1, Math.ceil(filterdBusinessData?.length / itemsPerPage));

    // const paginatedData = useMemo(() => {
    //     if (!filterdBusinessData?.length) return []; // Handle empty data case

    //     const start = (currentPage - 1) * itemsPerPage;

    //     return filterdBusinessData.slice(start, start + itemsPerPage).map(business => ({
    //         ...business,
    //         invoiceCount: state?.INVOICES?.filter(invoice => invoice?.companyId === business?.companyId)?.length || 0,
    //         customerCount: state?.CUSTOMERS?.filter(customer => customer?.companyId === business?.companyId)?.length || 0
    //     }));
    // }, [filterdBusinessData, currentPage, itemsPerPage, state?.CUSTOMERS]);

    // Ensure currentPage is within range
    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
        if (currentPage < 1) {
            setCurrentPage(1);
        }
    }, [currentPage, totalPages]);


    const sortCaret = (order, column) => {
        return (
            <span className="d-inline-flex align-items-center ms-2" >
                {!order ? (
                    <Icon icon="mdi:swap-vertical" className="text-muted" /> // Two arrows pointing up & down
                ) : order === "asc" ? (
                    <Icon icon="mdi:arrow-up-thick" className="text-muted" />
                ) : (
                    <Icon icon="mdi:arrow-down-thick" className="text-muted" />
                )}
            </span>
        );
    };


    const { SearchBar } = Search;

    const handleBusinessClick = (e, row, dispatch, navigate, isAllowed) => {
        e.preventDefault();
        if (!state?.USERID) {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
            return;
        }
        if (isAllowed) {
            dispatch({ type: actionType.SELECTEDBUSINESS, payload: row.companyId });
            navigate(`/business-view`); // or your path logic
        } else {
            navigate("/pricing");
        }
    };


    const columns = [
        {
            dataField: 'srNo',
            text: Languages[state?.LANGUAGE].s_r,
            headerAlign: "center",
            align: "center",
            sort: true,
            formatter: (cell, row) => {

                const accessibleIds = getAccessibleBusinessIds();
                const isAllowed = row.isShared
                    ? true // shared always viewable
                    : accessibleIds.includes(row.companyId); // own business limit apply

                return (
                    <span
                        style={{ marginLeft: -8, cursor: "pointer" }}
                        onClick={(e) => handleBusinessClick(e, row, dispatch, navigate, isAllowed)}
                    >
                        {cell}
                    </span>
                );
            },
            sortCaret: sortCaret,
        }
        ,
        {
            dataField: 'companyPhoto',
            text: Languages[state?.LANGUAGE].business_logo,
            headerStyle: { width: '10%' },
            sort: true,
            sortCaret: sortCaret,

            formatter: (cell, row) => {
                const accessibleIds = getAccessibleBusinessIds();
                const isAllowed = row.isShared
                    ? true // shared always viewable
                    : accessibleIds.includes(row.companyId); // own business limit apply

                if (!isAllowed && !row.isShared) {
                    return (
                        <i
                            className="fas fa-crown"
                            style={{ fontSize: "24px", color: "gold", marginLeft: "8px", cursor: "pointer" }}
                            onClick={(e) => handleBusinessClick(e, row, dispatch, navigate, isAllowed)}
                        ></i>
                    );
                }

                return (
                    <img
                        src={
                            cell ||
                            'https://ui-avatars.com/api/?name=' + encodeURIComponent(row?.companyName)
                        }
                        alt=""
                        className="flex-shrink-0 me-12 radius-8 rounded-circle border border-secondary p-2"
                        style={{
                            width: "50px",
                            height: "50px",
                            aspectRatio: "1 / 1",
                            objectFit: "contain",
                            cursor: "pointer"
                        }}
                        onClick={(e) => handleBusinessClick(e, row, dispatch, navigate, isAllowed)}
                    />
                );
            }
        },

        {
            dataField: 'companyName',
            text: Languages[state?.LANGUAGE].business_name,
            headerStyle: { width: '25%' },
            sort: true,
            sortCaret: sortCaret,
            // events: {
            //     onClick: (e, column, columnIndex, row, rowIndex) => {
            //         OnRowClick(row?.companyId);
            //     }
            // }
            formatter: (cell, row) => {
                const accessibleIds = getAccessibleBusinessIds();
                const isAllowed = row.isShared
                    ? true // shared always viewable
                    : accessibleIds.includes(row.companyId); // own business limit apply


                return (
                    <div
                        style={{ marginLeft: -8, cursor: "pointer" }}
                        onClick={(e) => handleBusinessClick(e, row, dispatch, navigate, isAllowed)}
                    >
                        <div>{cell}</div>
                        {row.isShared && (
                            <small className="text-secondary-light" style={{ fontSize: '11px', display: 'block', marginTop: '-4px' }}>
                                Shared by: {row.ownerName}
                            </small>
                        )}
                    </div>
                );
            },
        },
        {
            dataField: 'gstNumber',
            text: `${state?.TAXTYPE} Number`,

            headerStyle: { width: '15%' },
            sort: true,
            sortCaret: sortCaret,

            formatter: (cell, row) => {
                const accessibleIds = getAccessibleBusinessIds();
                const isAllowed = row.isShared
                    ? true // shared always viewable
                    : accessibleIds.includes(row.companyId); // own business limit apply

                const displayValue = cell && cell.trim() !== "" ? cell : "-";

                return (
                    <span
                        style={{ marginLeft: -8, cursor: "pointer" }}
                        onClick={(e) => handleBusinessClick(e, row, dispatch, navigate, isAllowed)}
                    >
                        {displayValue}
                    </span>
                );
            },
        },

        {
            dataField: 'invoiceCount',
            text: Languages[state?.LANGUAGE].invoice,
            headerAlign: "center",
            align: "center",
            headerStyle: { width: '10%' },
            sort: true,
            sortCaret: sortCaret,

            formatter: (cell, row) => {
                const accessibleIds = getAccessibleBusinessIds();
                const isAllowed = row.isShared
                    ? true // shared always viewable
                    : accessibleIds.includes(row.companyId); // own business limit apply

                const invoiceCount = state?.INVOICES?.filter(invoice => invoice?.companyId === row?.companyId)?.length || 0;

                const handleClick = (e) => {
                    e.preventDefault();
                    if (!state?.USERID) {
                        dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                        return;
                    }
                    if (isAllowed) {
                        dispatch({
                            type: actionType.SELECTEDBUSINESS,
                            payload: row.companyId
                        });
                        navigate("/invoice-list");
                    } else {
                        navigate("/pricing");
                    }
                };

                return (
                    <span
                        className="text-primary-400"
                        style={{ cursor: "pointer", marginLeft: -8 }}
                        onClick={handleClick}
                    >
                        {invoiceCount}
                    </span>
                );
            }
        }
        ,
        {
            dataField: 'customerCount',
            text: Languages[state?.LANGUAGE].customers,
            headerAlign: "center",
            align: "center",
            headerStyle: { width: '10%' },
            sort: true,
            sortCaret: sortCaret,

            formatter: (cell, row) => {
                const accessibleIds = getAccessibleBusinessIds();
                const isAllowed = row.isShared
                    ? true // shared always viewable
                    : accessibleIds.includes(row.companyId); // own business limit apply

                const customerCount = state?.CUSTOMERS?.filter(customer => customer?.companyId === row?.companyId)?.length || 0;

                const handleClick = (e) => {
                    e.preventDefault();
                    if (!state?.USERID) {
                        dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                        return;
                    }
                    if (isAllowed) {
                        dispatch({
                            type: actionType.SELECTEDBUSINESS,
                            payload: row.companyId,
                        });
                        navigate("/customer-list");
                    } else {
                        navigate("/pricing");
                    }
                };

                return (
                    <span
                        className="text-primary-400"
                        style={{ cursor: "pointer", marginLeft: -8 }}
                        onClick={handleClick}
                    >
                        {customerCount}
                    </span>
                );
            }
        }
        ,
        {
            dataField: 'creationDate',
            text: Languages[state?.LANGUAGE].issued_date,
            headerStyle: { width: '10%' },
            sort: true,
            sortCaret: sortCaret,

            formatter: (cell, row) => {
                const accessibleIds = getAccessibleBusinessIds();
                const isAllowed = row.isShared
                    ? true // shared always viewable
                    : accessibleIds.includes(row.companyId); // own business limit apply


                const timestamp = parseInt(cell?.length > 10 ? cell : cell * 1000);
                const dateStr = new Date(timestamp).toDateString();

                return (
                    <span
                        style={{ marginLeft: -8, cursor: "pointer" }}
                        onClick={(e) => handleBusinessClick(e, row, dispatch, navigate, isAllowed)}
                    >
                        {dateStr}
                    </span>
                );
            },
        },
        {
            dataField: 'action',
            text: Languages[state?.LANGUAGE].action,
            formatter: (cell, row) => {
                const accessibleIds = getAccessibleBusinessIds();
                const isAllowed = row.isShared
                    ? true // shared always viewable
                    : accessibleIds.includes(row.companyId); // own business limit apply


                const handleClick = (e, path) => {
                    e.preventDefault();
                    if (!state?.USERID) {
                        dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                        return;
                    }
                    if (isAllowed) {
                        dispatch({ type: actionType.SELECTEDBUSINESS, payload: row.companyId });
                        navigate(path);
                    } else {
                        navigate("/pricing");
                    }
                };

                return (
                    <>
                        <Link
                            to="#"
                            onClick={(e) => handleClick(e, "/business-view")}
                            className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                            data-bs-toggle="DefaultTooltipThree"
                            data-bs-placement="top"
                            data-bs-custom-class="tooltip-primary"
                            data-bs-title="View Business"
                        >
                            <Icon icon="iconamoon:eye-light" />
                        </Link>
                        <Link
                            to="#"
                            onClick={(e) => {
                                e.preventDefault();

                                if (row.isShared) {
                                    return; // ❌ रोक दो (do nothing)
                                }

                                handleClick(e, "/business-edit");
                            }}
                            className={`w-32-px h-32-px me-8 rounded-circle d-inline-flex align-items-center justify-content-center ${row.isShared
                                ? "bg-secondary-light text-muted cursor-not-allowed"
                                : "bg-success-focus text-success-main"
                                }`}
                            style={{ pointerEvents: row.isShared ? "none" : "auto", opacity: row.isShared ? 0.5 : 1 }}
                            data-bs-toggle="DefaultTooltipThree"
                            data-bs-placement="top"
                            data-bs-custom-class="tooltip-success"
                            data-bs-title={row.isShared ? "Shared business can't be edited" : "Edit Business"}
                        >
                            <Icon icon="lucide:edit" />
                        </Link>
                    </>
                );
            },
            headerStyle: { width: '10%' },
        }

    ];

    const OnRowClick = (companyId) => {
        if (!state?.USERID) {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
            return;
        }
        dispatch({ type: actionType.SELECTEDBUSINESS, payload: companyId })
        navigate("/business-view")
    }

    const handleSelection = (val) => {
        setItemsPerPage(val)
        setCurrentPage(1)
    };

    const getAccessibleBusinessIds = () => {
        const businesses = state?.BUSINESSES || [];

        // ✅ Only OWN businesses (exclude shared)
        const ownBusinesses = businesses.filter(b => !b.isShared);

        if (!ownBusinesses.length) return [];

        const lastPayment = state?.PAYMENT?.[state?.PAYMENT.length - 1];
        const userPlanName = lastPayment?.planName?.trim();

        const starterPlanName = process.env.REACT_APP_STARTER_PLAN_NAME;
        const professionalPlanName = process.env.REACT_APP_PROFESSIONAL_PLAN_NAME;
        const agencyPlanName = process.env.REACT_APP_AGENCY_PLAN_NAME;

        let accessLimit = 1;

        if (!state?.PREMIUM) {
            accessLimit = 1;
        } else if (userPlanName === starterPlanName) {
            accessLimit = 1;
        } else if (userPlanName === professionalPlanName) {
            accessLimit = 3;
        } else if (userPlanName === agencyPlanName) {
            accessLimit = ownBusinesses.length;
        }

        // ✅ Only last N OWN businesses
        return ownBusinesses
            .slice(-accessLimit)
            .map(b => b.companyId);
    };

    return (
        <div className="card">
            <div className="card-body">
                <ToolkitProvider keyField="companyId" data={filterdBusinessData} columns={columns} search>
                    {props => {
                        const searchText = props.searchProps.searchText?.toLowerCase() || "";

                        // Filter full business data based on search
                        const filteredData = filterdBusinessData.filter(business => {
                            return (
                                business.companyName?.toLowerCase().includes(searchText) ||
                                business.gstNumber?.toLowerCase().includes(searchText)
                            );
                        });

                        // Apply pagination AFTER search
                        const start = (currentPage - 1) * itemsPerPage;
                        const paginatedSearchData = filteredData
                            .slice(start, start + itemsPerPage)
                            .map((business, index) => ({
                                ...business,
                                srNo: (currentPage - 1) * itemsPerPage + index + 1,
                                invoiceCount: state?.INVOICES?.filter(inv => inv?.companyId === business?.companyId)?.length || 0,
                                customerCount: state?.CUSTOMERS?.filter(cust => cust?.companyId === business?.companyId)?.length || 0
                            }));

                        return (
                            <>
                                {/* Search Bar + Add Business */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <SearchBar
                                        {...props.searchProps}
                                        placeholder={Languages[state?.LANGUAGE].search_business}
                                        className="form-control w-auto"
                                    />
                                    <div className="d-flex flex-wrap align-items-center gap-3 display_business">
                                        <Link
                                            to="#"
                                            onClick={(e) => {
                                                e.preventDefault();

                                                if (!state?.USERID) {
                                                    dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                    return;
                                                }

                                                const currentYear = new Date().getFullYear();

                                                const lastPayment = state?.PAYMENT?.[state?.PAYMENT.length - 1];
                                                const userPlanName = lastPayment?.planName?.trim();
                                                const starterPlanName = process.env.REACT_APP_STARTER_PLAN_NAME;
                                                const professionalPlanName = process.env.REACT_APP_PROFESSIONAL_PLAN_NAME;
                                                const agencyPlanName = process.env.REACT_APP_AGENCY_PLAN_NAME;

                                                let newuserPlanName = starterPlanName; // default = Starter

                                                if (
                                                    userPlanName === starterPlanName ||
                                                    userPlanName === professionalPlanName ||
                                                    userPlanName === agencyPlanName
                                                ) {
                                                    // ✅ If already new plan → keep same
                                                    newuserPlanName = userPlanName;
                                                }

                                                if (!state?.BUSINESSES?.length) {
                                                    navigate("/business-add");
                                                    return;
                                                }

                                                const currentYearBusinessCount = (state?.BUSINESSES || []).filter(b => {
                                                    return new Date(parseInt(b.creationDate)).getFullYear() === currentYear;
                                                }).length;

                                                // Free users
                                                if (!state?.PREMIUM) {
                                                    if (currentYearBusinessCount >= 1) { // Free → 1 business
                                                        setLimitPlanName("Free Plan");
                                                        setLimitValue(1);
                                                        setIsDisplayLimitModel(true);
                                                        return;
                                                    }
                                                    navigate("/business-add");
                                                    return;
                                                }


                                                // Starter plan
                                                if (newuserPlanName == process.env.REACT_APP_STARTER_PLAN_NAME) {

                                                    const maxBusinesses = parseInt(process.env.REACT_APP_STARTER_PLAN_BUSINESS_LIMIT || "1");

                                                    if (currentYearBusinessCount >= maxBusinesses) {
                                                        setLimitPlanName(process.env.REACT_APP_STARTER_PLAN_NAME);
                                                        setLimitValue(maxBusinesses);
                                                        setIsDisplayLimitModel(true);
                                                        return;
                                                    }
                                                    navigate("/business-add");
                                                    return;
                                                }
                                                // Professional plan
                                                if (newuserPlanName == process.env.REACT_APP_PROFESSIONAL_PLAN_NAME) {
                                                    const maxBusinesses = parseInt(process.env.REACT_APP_PROFESSIONAL_PLAN_BUSINESSES_LIMIT || "3", 10);
                                                    if (currentYearBusinessCount >= maxBusinesses) {
                                                        setLimitPlanName(process.env.REACT_APP_PROFESSIONAL_PLAN_NAME);
                                                        setLimitValue(maxBusinesses);
                                                        setIsDisplayLimitModel(true);
                                                        return;
                                                    }
                                                    navigate("/business-add");
                                                    return;
                                                }

                                                // Agency → unlimited
                                                if (newuserPlanName == process.env.REACT_APP_AGENCY_PLAN_NAME) {
                                                    navigate("/business-add");
                                                    return;
                                                }

                                                // Fallback → allow
                                                navigate("/business-add");
                                            }}
                                            className="btn btn-sm btn-primary-600"
                                        >

                                            <i className="ri-add-line" />
                                            <span className="hide-text"> {Languages[state?.LANGUAGE].create_business}</span>
                                        </Link>
                                    </div>
                                </div>

                                {/* Table */}
                                <div className="table-responsive">
                                    <BootstrapTable
                                        {...props.baseProps}
                                        bootstrap4
                                        bordered={false}
                                        data={paginatedSearchData} // paginated after search
                                        wrapperClasses={`custom-table-border invoice-table ${localStorage.getItem("theme") === "dark" ? "table-dark" : "table-light"}`}
                                        noDataIndication={() => <DataNotFoundView height={400} />}
                                        rowStyle={{ cursor: 'pointer' }}
                                    />
                                </div>

                                {/* Pagination */}
                                {filteredData.length > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        {/* Items Per Page Dropdown */}
                                        <div className="d-flex align-items-center gap-2 entry_per_page">
                                            <div className="dropdown">
                                                <button
                                                    className="btn btn-outline-primary-600 not-active px-18 py-6 dropdown-toggle toggle-icon"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    {itemsPerPage}
                                                </button>
                                                <ul className="dropdown-menu shadow-md">
                                                    {[5, 10, 15, 20].map(value => (
                                                        <li key={value}>
                                                            <Link
                                                                className={`dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 ${itemsPerPage === value && "bg-primary-50"}`}
                                                                onClick={() => handleSelection(value)}
                                                            >
                                                                {value}
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <span className="text-secondary-light">{Languages[state?.LANGUAGE]?.entries_per_page}</span>
                                        </div>

                                        <div className="ms-auto">
                                            <PaginationView
                                                currentPage={currentPage}
                                                totalPages={Math.ceil(filteredData.length / itemsPerPage)}
                                                handlePageChange={setCurrentPage}
                                            />
                                        </div>
                                    </div>
                                )}
                            </>
                        );
                    }}
                </ToolkitProvider>



                <FreePlanLimitReachedModal isOpen={isDisplayLimitModel} onClose={() => setIsDisplayLimitModel(false)} limit={limitValue} planName={limitPlanName} type={"Business"} />

            </div>
        </div>
    );
};

export default BusinessTableDataLayer;
